import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { permitApplications as seedPermits, type PermitApplication } from '../data/permis';
interface PermitsContextValue {
  permits: PermitApplication[];
  /** Ajoute une demande en tête de liste, sans doublon d'identifiant. */
  addPermit: (permit: PermitApplication) => void;
  /** Encaisse les frais d'une demande acceptée et émet le permis. */
  payPermitFee: (id: string, method: 'carte' | 'comptoir') => void;
}
const PermitsContext = createContext<PermitsContextValue>({
  permits: seedPermits,
  addPermit: () => {},
  payPermitFee: () => {}
});
export function PermitsProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [permits, setPermits] = useState<PermitApplication[]>(seedPermits);
  const addPermit = useCallback((permit: PermitApplication) => {
    setPermits(current => current.some(item => item.id === permit.id) ? current : [permit, ...current]);
  }, []);
  const payPermitFee = useCallback((id: string, method: 'carte' | 'comptoir') => {
    setPermits(current => current.map(permit => {
      if (permit.id !== id) return permit;
      // Le paiement en ligne émet le permis ; au comptoir, il reste à acquitter sur place.
      if (method === 'comptoir') return permit;
      return {
        ...permit,
        status: 'emis',
        feeStatus: 'paye',
        timeline: [...permit.timeline, {
          date: 'Aujourd’hui',
          label: `Frais de ${permit.fee} payés`
        }, {
          date: 'Aujourd’hui',
          label: 'Permis émis'
        }],
        attachments: [...permit.attachments, {
          name: `permis-${permit.reference.replace('#PER-', '')}.pdf`,
          type: 'pdf',
          size: '204 Ko'
        }]
      };
    }));
  }, []);
  const value = useMemo(() => ({
    permits,
    addPermit,
    payPermitFee
  }), [permits, addPermit, payPermitFee]);
  return <PermitsContext.Provider value={value} data-id="element-2874" data-mp="1duepwq6fzuus">{children}</PermitsContext.Provider>;
}
export function usePermits(): PermitsContextValue {
  return useContext(PermitsContext);
}